/**
 * Route path constants — single source of truth for all navigation.
 * No magic strings in components.
 */
export const ROUTES = {
  TODAY: "/",
  EVENING: "/evening",
  UPCOMING: "/upcoming",
  SOMEDAY: "/someday",
  ANYDAY: "/anyday",
  LOGBOOK: "/logbook",
  TRASH: "/trash",
  INBOX: "/inbox",
  SEARCH: "/search",
  RECURRING: "/recurring",
  ROUTINES: "/routines",
  SETTINGS: "/settings",
  SIGNIN: "/signin",
  PROJECT: (id: string) => `/project/${id}`,
  LIST: (id: string) => `/list/${id}`,
  AREA: (id: string) => `/area/${id}`,
  TAG: (tag: string) => `/tag/${encodeURIComponent(tag)}`,
  TAGS: "/tags",
  LATER_PROJECTS: "/later-projects",
  INVITES: "/invites",
  PRIVACY: "/privacy",
  TERMS: "/terms",
  ERROR: "/error",
} as const
